import { cn } from "@/utils/css";
import {
    LoadboardTableCell,
    LoadboardTimestamps,
    LoadboardBidCard,
    LoadboardCargoInfo,
    LoadboardBrokerInfo,
    LoadboardMapSection,
} from "@/components/dataPages/loadboard";
import { TableRow } from "@/components/common/table/table";
import { useMemo } from "react";

export const LoadboardToggleRow = ({ load, isOpen, withTimestamps = true, counterPanel }) => {
    // Use existing routeAnalysis data from load instead of making API call
    const CMRate = useMemo(() => {
        const routeAnalysis = load.routeAnalysis;
        if (!routeAnalysis?.estimatedPrice) {
            return { data: null, isLoading: false, isError: false };
        }
        const estimatedDistance = routeAnalysis.estimatedDistance || load.loadDistance;
        return {
            data: {
                suggestedRate: routeAnalysis.estimatedPrice,
                suggestedRpm: estimatedDistance ? routeAnalysis.estimatedPrice / estimatedDistance : 0,
            },
            isLoading: false,
            isError: false,
        };
    }, [load.routeAnalysis, load.loadDistance]);

    return (
        <TableRow className="border-0 hover:bg-transparent">
            <LoadboardTableCell
                colSpan={12}
                className={cn("border-0 border-none transition-all ease-linear", {
                    "leading-[0]": !isOpen,
                })}
                innerClassName={cn("overflow-hidden transition-all ease-linear p-0 max-h-0 h-0", {
                    "max-h-[388px] h-[388px]": isOpen && withTimestamps,
                    "max-h-[353px] h-[353px]": isOpen && !withTimestamps,
                })}
            >
                <div className="p-4 flex flex-col w-full">
                    <div className="flex flex-col lg:flex-row w-full gap-4 h-[321px]">
                        <LoadboardMapSection load={load} isOpen={isOpen} />
                        <div className="w-full lg:w-[31.152205%] flex flex-col h-[321px] gap-4">
                            <LoadboardCargoInfo load={load} />
                            <LoadboardBrokerInfo load={load} />
                        </div>
                        <LoadboardBidCard load={load} CMRate={CMRate} isOpen={isOpen} counterPanel={counterPanel} />
                    </div>
                    {withTimestamps ? <LoadboardTimestamps createdAt={load.createdAt} updatedAt={load.updatedAt} /> : null}
                </div>
            </LoadboardTableCell>
        </TableRow>
    );
};
